/* eslint-disable */
import {
  Box,
  Typography,
} from '@mui/material'

import CardTAG from '../CardTAG'
import React from 'react'
import FormLayout from '../forms/FormLayout'
import { useDispatch, useSelector } from 'react-redux'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { AppDispatch } from '../../store'
import {
  updateAnswerText,
  findItemByUuid
  
} from '../../store/reports/reportsSlice'
import { IQuestionComponent } from './types'

import DateRangePicker from '../../components/DateRangePicker'
import authSelectors from '../../store/auth/authSelectors'



const DateQuestionComponent: React.FC<IQuestionComponent> = ({
  questionObj,
  question,
  questionUUID,
  questionId,
  questionOptions,
  control,
  fieldName,
  unregister,
  setValue,
  setAnswersFiles,
  answers = [],
  answer: _answer,
  parent,
  previewOnly = false,
}) => {
  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const dispatch = useDispatch<AppDispatch>()
  const getAnswer = () => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, questionUUID)
    }
    return useSelector(reportsSelectors.answersToCaseTypeQuestion(questionUUID))
  }
  const answer = _answer ? _answer : getAnswer()

  


  const onChangeHandler = (d: Date) => {
    dispatch(
      updateAnswerText({
        answerUUID: answer?.uuid,
        answerText: d?.toDateString(),
        parentUUID: parent?.uuid
      }),
    )
  }

  const selectedDate = answer?.answer?.text.trim() ? new Date(Date.parse(answer?.answer?.text)) : null

  return (
    <div id={`${questionId}`}>
      <CardTAG
        questionCard={true}
        color={`${previewOnly ? 'tagBoxArchive' : 'tagBoxSuccess'}`}
        title={
          <Box sx={{ wordWrap: 'break-word', whiteSpace: 'unset', textOverflow: 'unset' }}>
            <Typography
              variant='h4'
              sx={{
                wordWrap: 'break-word',
                overflow: 'hidden',
              }}
            >
              {question}
            </Typography>
          </Box>
        }
        
      >
            <FormLayout>
              <DateRangePicker disabled={!userEditAccess || previewOnly} setDate={onChangeHandler} date={selectedDate} />
            </FormLayout>
        
        </CardTAG>
      </div>
  )
  
}

export default DateQuestionComponent
